<!-- The reused header of questions. -->
<template>
	<header>
		<h2
			autofocus
			v-html="DOMPurify.sanitize(questionData.text)"
			:id="`header-${questionData.number}`"
			:data-no-description="questionData.descriptionAbove === `` ? `` : false"
		></h2>
		<p v-if="questionData.descriptionAbove" v-html="DOMPurify.sanitize(questionData.descriptionAbove)"></p>
		<p v-if="this.hasRequiredAnswers && !this.state.layout.HideRequiredFieldsText" data-required-info>
			{{ this.$store.getters.textResource(`rs_mandatory_fields`)}}
		</p>
		<template v-if="questionData.media">
			<template v-for="(media, index) in questionData.media">
				<template v-if="isGraphicImage">
					<img
						v-if="media.mediaType === 'Image'"
						:src="`${state.surveyInfo.domain}/v1/${media.url}`"
						:id="`question-${questionData.number}_media-image`"
						:key="`question-image-${index}`"
						:alt="media.alt"
						data-question-image
					/>
					<media
						v-else
						:url="media.url"
						:video-id="questionData.media[`${index}`].videoIdentifier"
						:alt="media.alt"
						:type="media.mediaType"
						:extension="media.fileExtension"
						:showImage="showImage"
						:key="`media-${index}`"
						:id="`question-${questionData.number}_media-video`"
					/>
				</template>
			</template>
		</template>
	</header>
</template>

<script>
import media from "@/components/Media";

export default {
	name: `question-header`,
    inject: ['DOMPurify'],
	components: {
		media,
	},
	props: {
		// The data of the question that this answer is a part of
		questionData: {
			type: Object,
		},
		showImage: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		state: function () {
			return this.$store.state;
		},
		settings: function () {
			return this.state.settings;
		},
		hasRequiredAnswers: function () {
			let hasRequiredAnswer;
			let findRequiredAnswers = false;
			let questionType = this.questionData.subQuestions ? this.questionData.subQuestions[0].answers : this.questionData.answers;

			findRequiredAnswers = questionType.find((answer) => answer.validation.required && answer.validation !== undefined);

			if (findRequiredAnswers !== undefined) {
				hasRequiredAnswer = findRequiredAnswers.validation.required;
			}

			return hasRequiredAnswer;
		},
		isGraphicImage(){
			const questionType = this.questionData.type;
			return questionType !== 'TagIt' && questionType !== 'Swipe' && questionType !== 'ImageSingle' && questionType !== 'ImageMulti';
		}
	}
};
</script>

<style scoped>
img[data-is-clickable] {
	cursor: pointer;
    max-width: 100%;
}

[data-question-image] {
	max-width: 100%;
}

dialog img {
    width: auto;
    max-width: fit-content;
}

[question]:first-of-type header {
		padding-top: 15px;
	
}
[question] header{
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

header {
	background: #fff;
	padding: 5px 40px 5px 35px;

	h2 {
		margin-bottom: 0;
		width: 100%;
		font-size: calc(var(--QuestionStyling-font-size) * 1px);
		font-family: var(--QuestionStyling-font-family-public-name);
		color: var(--QuestionStyling-color);
	}

	p {
		font-size: calc(var(--DescriptionStyling-font-size) * 1px);
		font-family: var(--DescriptionStyling-font-family-public-name);
		color: var(--DescriptionStyling-color);
		margin-top: 5px;
		width: 100%;
	}
	[data-required-info] {
		font-style: italic;
	}
}

header h2[data-no-description] {
	margin-bottom: 17px;
}
</style>